// extracted by mini-css-extract-plugin
export default {"component":"Skeleton__component--slots-NMGxd","blink":"Skeleton__blink--slots-EA3UT"};